import { Injectable, signal, WritableSignal } from '@angular/core';
import { Globals } from '../../Models/common/Globals';


@Injectable({
  providedIn: 'root'
})
export class RootScopeService {
  globals = new Globals();
  private _viewContactsFlag: WritableSignal<boolean | undefined> = signal(undefined);
  private _masterClientVisible: WritableSignal<boolean | undefined> = signal(undefined);
  private _cbemVisible: WritableSignal<boolean | undefined> = signal(undefined);
  private _invoiceExtractVisible: WritableSignal<boolean | undefined> = signal(undefined);
  private _referralVisible: WritableSignal<boolean | undefined> = signal(undefined);
  private _addGbReferralsVisible: WritableSignal<boolean | undefined> = signal(undefined);
  private _editGbReferralsVisible: WritableSignal<boolean | undefined> = signal(undefined);
  private _deleteGbReferralsVisible: WritableSignal<boolean | undefined> = signal(undefined);
  private _dynamoUtilityVisible: WritableSignal<boolean | undefined> = signal(undefined);
  private _launchDarklyReady: WritableSignal<boolean> = signal(false);

  setViewContactsFlag(val: boolean){
    this.globals.viewContactsFlag = val;
    this._viewContactsFlag.set(val);
  }

  viewContactsFlag(){
    return this._viewContactsFlag();
  }

  setMasterClientVisible(val: boolean){
    this._masterClientVisible.set(val);
  }
  masterClientVisible(){
    return this._masterClientVisible();
  }

  setCbemVisible(val: boolean){
    this._cbemVisible.set(val);
  }
  cbemVisible(){
    return this._cbemVisible();
  }

  setInvoiceExtractVisible(val: boolean){
    this._invoiceExtractVisible.set(val);
  }
  invoiceExtractVisible(){
    return this._invoiceExtractVisible();
  }

  setReferralVisible(val: boolean){
    this._referralVisible.set(val);
  }
  referralVisible(){
    return this._referralVisible();
  }

  setAddGbReferralsVisible(val: boolean){
    this._addGbReferralsVisible.set(val);
  }
  addGbReferralsVisible(){
    return this._addGbReferralsVisible();
  }

  setEditGbReferralsVisible(val: boolean){
    this._editGbReferralsVisible.set(val);
  }
  editGbReferralsVisible(){
    return this._editGbReferralsVisible();
  }

  setDeleteGbReferralsVisible(val: boolean){
    this._deleteGbReferralsVisible.set(val);
  }
  deleteGbReferralsVisible(){
    return this._deleteGbReferralsVisible();
  }

  setDynamoUtilityVisible(val: boolean){
    this._dynamoUtilityVisible.set(val);
  }
  dynamoUtilityVisible(){
    return this._dynamoUtilityVisible();
  }

  // Readiness flag to indicate initial LD fetch complete
  setLaunchDarklyReady(val: boolean){
    this._launchDarklyReady.set(val);
  }
  launchDarklyReady(){
    return this._launchDarklyReady();
  }
}
